module.exports = __webpack_public_path__ + "static/assets/b0403e1049d8f6d9770af3ec5e2dc775.png";